<div class="border-grey-3 px-xl border-b-1">
  <div class="py-sm gap-xs flex items-center">
    <nav class="gap-xs paragraph-medium-medium" hlmBreadcrumb>
      <ol hlmBreadcrumbList>
        <li hlmBreadcrumbItem>
          <a class="paragraph-medium-medium text-grey-7 underline" (click)="navigateTo('etape')" hlmBreadcrumbLink>
            {{ etape()?.nom }}
          </a>
        </li>
        <li class="text-grey-7" hlmBreadcrumbSeparator>
          <ng-icon hlm size="sm" name="lucideSlash" />
        </li>
        <li hlmBreadcrumbItem>
          <button
            class="paragraph-medium-medium text-grey-7 flex cursor-pointer items-center gap-1"
            [hlmDropdownMenuTrigger]="modulesDropdown"
          >
            {{ moduleSelected()?.nom }}
            <ng-icon hlm size="sm" name="lucideChevronDown" />
          </button>
          <ng-template #modulesDropdown>
            <hlm-dropdown-menu>
              @for (module of modules() | trierPar: 'indice'; track module.id) {
                <a
                  [checked]="module.id === moduleSelected()?.id"
                  (click)="navigateTo('module', module.id)"
                  hlmDropdownMenuRadio
                >
                  <hlm-dropdown-menu-radio-indicator />
                  <span>{{ module.nom }}</span>
                </a>
              }
            </hlm-dropdown-menu>
          </ng-template>
        </li>
        <li class="text-grey-7" hlmBreadcrumbSeparator>
          <ng-icon hlm size="sm" name="lucideSlash" />
        </li>
        @if (!activite()) {
          <li hlmBreadcrumbItem>
            <a (click)="navigateTo('sequences')" hlmBreadcrumbPage> Séquences </a>
          </li>
        }

        @if (activite()) {
          <li hlmBreadcrumbItem>
            <a
              class="paragraph-medium-medium text-grey-7 underline"
              (click)="navigateTo('sequences')"
              hlmBreadcrumbLink
            >
              Séquences
            </a>
          </li>
          <li class="text-grey-7" hlmBreadcrumbSeparator>
            <ng-icon hlm size="sm" name="lucideSlash" />
          </li>
          <li hlmBreadcrumbItem>
            <span hlmBreadcrumbPage>{{ activite()?.nom }}</span>
          </li>
        }
      </ol>
    </nav>
  </div>
  <ng-content />
</div>
